import React from 'react';
import { useParams } from 'react-router';
import { useQueryClient } from 'react-query';
import RoomBlock from './components/RoomBlock/RoomBlock';
import DocumentsBlock from './components/DocumentsBlock/DocumentsBlock';
import CommonInfoBlock from './components/CommonInfoBlock/CommonInfoBlock';
import { roomQueryKeys } from '../../queries/queryKeys';
import styles from './AboutRoom.module.scss';

const AboutRoom = () => {
  const params = useParams();

  const queryClient = useQueryClient();

  const room = queryClient.getQueryData(roomQueryKeys(params.roomId));

  return (
    <div className={styles.root}>
      <RoomBlock room={room} />
      <DocumentsBlock room={room} />
      <CommonInfoBlock room={room} />
    </div>
  );
};

export default AboutRoom;
